import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/ui/button';
import { Dialog, DialogClose, DialogContent } from 'src/components/ui/dialog';
import { Icon } from 'src/components/ui/icon';
import { Typography } from 'src/components/ui/typography';
import { sidebarIcons } from 'src/layouts/SidebarV2/icons';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

export interface DeleteChatDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const DeleteChatDialog = ({
  open,
  onOpenChange,
  onConfirm
}: DeleteChatDialogProps) => {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        hideDefaultClose
        className="tw:max-w-100 tw:rounded-3xl tw:p-none"
      >
        <div className="tw:flex tw:flex-col tw:items-center tw:gap-s tw:px-2xl tw:py-4xl">
          <Icon
            icon={sidebarIcons.trash}
            size={32}
            colorClass="tw:text-icon-error"
          />
          <Typography
            variant="h3"
            align="center"
            colorClass="tw:text-text-primary"
          >
            {t(T.deleteChat)}
          </Typography>
          <Typography
            variant="b1"
            align="center"
            colorClass="tw:text-text-secondary"
          >
            {t(T.confirmDeleteChat)}
          </Typography>
        </div>

        <div className="tw:flex tw:items-center tw:justify-between tw:gap-l tw:border-t tw:border-solid tw:border-border-secondary tw:px-2xl tw:py-m">
          <DialogClose asChild>
            <Button hierarchy="destructive" size="small" text={t(T.cancel)} />
          </DialogClose>
          <Button
            hierarchy="primary"
            size="small"
            text={t(T.yesDeleteIt)}
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { DeleteChatDialog };
